module.exports = __webpack_public_path__ + "img/ionova.fbc58d14.jpg";